module.exports = __webpack_public_path__ + "48891473d04de0dafaca23710f8b4a21.png";